/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isApiSupported = function isApiSupported(api) {
  return api in window;
};

exports.default = isApiSupported;
